export default "__VITE_ASSET__ByyPpB1x__"